<template>
  <div class="module-app-container" id="module-container">
    <Help :info="info" :currentStep="showableModule === 'ap' ? 5 : 6" />
    <div class="flex flex-col items-center justify-center h-screen">
      <Diagram
        @makereport="_makeReport"
        ref="diagram"
        class="absolute opacity-0 pointer-events-none"
        :class="{ 'opacity-100 pointer-events-auto': showableModule === 'ap' }"
        :key="datas.length + updateKey"
        :circles="datas"
        @updatedcategory="editCategory"
      />
      <RelationDiagram
        @makereport="_makeReport"
        ref="reldiagram"
        class="absolute opacity-0 pointer-events-none"
        :class="{ 'opacity-100 pointer-events-auto': showableModule === 'ar' }"
        :key="datas.length"
        :circles="datas"
      />
    </div>

    <div class="fixed flex top-24 gap-x-2 right-8">
      <div class=" btn btn-primary btn-sm right-8" @click="changeModule">
        <span class="cm--text">
          <i
            v-if="showableModule === 'ar'"
            class="la la-angle-double-left cm--ico"
          ></i>
          {{
            showableModule === "ap"
              ? "Analyse relationnelle des acteurs"
              : "Analyse des acteurs"
          }}
          <i
            v-if="showableModule === 'ap'"
            class="la la-angle-double-right cm--ico"
          ></i>
        </span>
      </div>
    </div>

    <div
      class="strato-modal z-[999]"
      v-show="dialogCategorie"
      @click.self="closeCategorieModal"
    >
      <div
        class=" modal-condtainer card bg-base-200 text-base-content animate__animated animate__fadeInDown"
        id="strato-modal"
      >
        <form class="card-body">
          <div class="card-title">
            <h1>Modifier la categorisation</h1>
            <p class="text-sm italic font-bold text-secondary">
              {{ editedCategorisation.ppNom }}
              <span>({{ editedCategorisation.ppAbbre }})</span>
            </p>
            <span
              class="absolute top-4 right-4"
              @click.stop="closeCategorieModal"
            >
              <i class="la la-times"></i>
            </span>
          </div>

          <div class="modal-body">
            <div id="app-cat">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Type</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.ppType"
                >
                  <option value="1">
                    Autre Partie Prénante (APP)
                  </option>
                  <option value="2">
                    Partie Prenante Institutionnelle (PPI)
                  </option>
                  <option value="3"
                    >Partenaire Technique et Financier (PTF)</option
                  >
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">Influence</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.ppInfluence"
                >
                  <option value="1">Direct</option>
                  <option value="2">Assez direct</option>
                  <option value="3">Peu direct</option>
                  <option value="4">Indirect</option>
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">Implication</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.ppImplication"
                >
                  <option value="1">Engagé</option>
                  <option value="2">Moins engagé</option>
                  <option value="3">Indécis</option>
                </select>
              </div>
            </div>
          </div>

          <div class="justify-center card-actions">
            <div
              class="btn btn-primary"
              :class="{ loading: loading }"
              @click="updateCategory"
            >
              Modifier
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Bouton pour changer de mondule -->
  </div>
</template>

<script>
import globalMixins from "@/utils/mixins/mixin.js";
import Diagram from "@/components/APPC/Diagram.vue";
import RelationDiagram from "@/components/APPC/RelationDiagram.vue";
import Help from "@/components/Help.vue";

export default {
  mixins: [globalMixins],
  components: { Help, Diagram, RelationDiagram },

  data() {
    return {
      dialogCategorie: false,
      updateKey: "",
      loading: false,
      showableModule: "ap",
      generating: false,
      editedCategorisation: {},
      typePp: [
        {
          id: "1",
          value: "Autre Partie Prenante (APP)",
          label: "Autre Partie Prenante (APP)"
        },
        {
          id: "2",
          value: "Partie Prenante Institutionnelle (PPI)",
          label: "Partie Prenante Institutionnelle (PPI)"
        },
        {
          id: "3",
          value: "Partenaire Technique et Financier (PTF)",
          label: "Partenaire Technique et Financier (PTF)"
        }
      ], // types des acteurs

      influencePp: [
        { id: "1", value: "Direct" },
        { id: "2", value: "Assez direct" },
        { id: "3", value: "Peu direct" },
        { id: "4", value: "Indirect" }
      ], // influence des acteurs

      implicationPp: [
        { id: "1", value: "Engagé" },
        { id: "2", value: "Peu engagé" },
        { id: "3", value: "Indécis" }
      ] // Implication des acteurs
    };
  },

  computed: {
    info() {
      return {
        name: this.currentModule?.name,
        description: this.currentModule?.moduleDescription
      };
    }
  },

  async mounted() {
    await this.loadData();
  },

  methods: {
    async loadData() {
      if (this.currentFile === null) this.datas = [];
      else {
        //this.datas = (localStorage.getItem('temp-analyse-acteurs-' + this.currentFile.name) !== null) ? JSON.parse(localStorage.getItem('temp-analyse-acteurs-' + this.currentFile.name)) : []
        await this.$axios.get(
          "/CategorisationPPsQueries/GetCategorisationPPAnalysis/" +
            this.currentFile.id
        );
        var response = await this.$axios.get(
          "/APAnalysisStores/GetAPAnalysisStoresByFileID/" + this.currentFile.id
        );

        this.datas = response.data.map(x => ({
          ...x,
          id: x.partiePrenanteID,
          analysisID: x.apAnalyseID,
          abbreviation: x.ppAbbre ?? "??",
          name: x.ppNom,
          role: x.ppRole,
          type: {
            ...this.typePp.find(y => y.id == x.ppType),
            label: undefined
          },
          influence: this.influencePp.find(y => y.id == x.ppInfluence),
          implication: this.implicationPp.find(y => y.id == x.ppImplication)
        }));
      }
    },
    closeCategorieModal() {
      this.dialogCategorie = false;
    },
    editCategory(item) {
      this.dialogCategorie = true;
      this.editedCategorisation = item;
      console.log(item);
    },

    async updateCategory() {
      this.loading = true;
      await this.$axios.put(
        "/APAnalysisStores/PutAPAnalysisStore/" +
          this.editedCategorisation.apAnalyseID,
        this.editedCategorisation
      );
      //!! Mettre a jour de manier local apres
      await this.loadData();
      this.updateKey = Date.now();
      this.loading = false;
      this.closeCategorieModal();
    },
    async _makeReport() {
      this.generating = true;
      this.$swal.fire("Edition du rapport");
      this.$swal.showLoading();

      var pdfData = {
        module: this.currentModule,
        folder: this.currentFolder,
        file: this.currentFile,
        actors: window._.sortBy(this.datas, "name"),
        actorLabel: "Acteurs",
        actorKey: "abbreviation",
        titles: [
          "Identification des acteurs",
          "Classification des acteurs en fonction des trois catégories",
          "Définition des rélations entre les acteurs",
          "Visualisation du diagramme de l'analyse du jeu des acteurs"
        ],
        identificationLabel: ["Abbreviation", "Acteur", "Rôle"],
        identificationKey: ["abbreviation", "name", "role"],
        categoriesLabel: ["Acteur", "Type", "Influence", "Implication"],
        categoriesKey: ["type", "influence", "implication"],
        images: [
          /* { data: "", legend: "", title: "" } */
        ]
      };
      var im1 = await this.$refs.diagram.downloadImage();
      var im2 = await this.$refs.reldiagram.downloadImage();

      pdfData.images.push(im1, im2);
      console.log(pdfData);
      this.$swal.hideLoading();

      this.$toast.fire({ title: "Le rapport a été edité", icon: "success" });
      this.makeReport(pdfData);
    },

    changeModule() {
      this.showableModule === "ap"
        ? (this.showableModule = "ar")
        : (this.showableModule = "ap");
      this.currentDiagramId = 0;
      this.handleResize();
    },

    async saveLocal() {
      localStorage.setItem(
        "temp-analyse-acteurs-" + this.currentFile.name,
        JSON.stringify(this.datas)
      );
    }
  }
};
</script>
